import { CrossUI, Email, Mobile } from 'phx-core';

import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { FeatureUpgradeService } from '@misc/upsell/upgrade.service';
import { NzMessageService } from 'ng-zorro-antd';
import { CTA_ACTION_TYPES, EXPANSION_UPSELL_TYPES, ExpansionUpsellService } from '../../service';

import { IUpsellCTA } from '../../interface';

type UpsellType = keyof typeof EXPANSION_UPSELL_TYPES;

@Component({
  selector: 'app-expansion-upsells-modal',
  templateUrl: './upsell-modal.component.html',
  styleUrls: ['./upsell-modal.component.scss'],
})
export class ExpansionUpsellsUpsellModalComponent implements OnChanges {
  @Output() public onDismiss: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onComplete: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onPrimaryCTACLick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onSecondaryCTACLick: EventEmitter<void> = new EventEmitter<void>();
  @Input() public heading: SafeHtml;
  @Input() public body: SafeHtml;
  @Input() public assetURL: string = '';
  @Input() public isVisible: boolean = false;
  @Input() public CTAs: IUpsellCTA[] = [];
  @Input() public industry: string;
  @Input() public parentUpsell: UpsellType;
  @Input() public upsellId: string;

  public upsellType: UpsellType = EXPANSION_UPSELL_TYPES.MODAL as UpsellType;
  public mobileIcon: string = Mobile;
  public emailIcon: string = Email;
  public crossIcon: string = CrossUI;

  constructor(
    private service: ExpansionUpsellService,
    private featureUpgradeService: FeatureUpgradeService,
    private message: NzMessageService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible'] && changes['isVisible'].currentValue) {
      this.isVisible = changes['isVisible'].currentValue;

      if (this.isVisible) {
        this.service.trackEvent(this.upsellType, this.industry, null, 'View');
      }
    }
  }

  public dismiss(): void {
    this.onDismiss.emit();
  }

  public handleCTAClick(cta: IUpsellCTA): void {
    if (cta.action.type === CTA_ACTION_TYPES.generateLead) {
      this.featureUpgradeService.genericUpsellWithCustomProps(
        cta.action.campaign_name,
        this.getCTAText(cta),
        cta.action.offer_type,
        cta.action.utm_content,
        cta.action.product_interest,
      ).subscribe(() => {
        this.onClose.emit();
        if (this.parentUpsell === EXPANSION_UPSELL_TYPES.SIDEBAR) {
          this.service.markSidebarUpsellAsCompleted(this.upsellId);
          this.onComplete.emit();
        } else {
          this.service.markUpsellAsCompleted(this.parentUpsell, this.industry);
        }
        this.service.trackEvent(this.upsellType, this.industry, null, cta);
        this.message.success($localize`Thank you for your interest. We will reach out to you shortly.`);
      });
    }
    if (cta.action.type === CTA_ACTION_TYPES.learnMore) {
      this.featureUpgradeService.genericUpsellWithCustomProps(
        cta.action.campaign_name,
        this.getCTAText(cta),
        cta.action.offer_type,
        cta.action.utm_content,
        cta.action.product_interest,
      ).subscribe(() => {
        this.onClose.emit();
        if (this.parentUpsell === EXPANSION_UPSELL_TYPES.SIDEBAR) {
          this.service.markSidebarUpsellAsTemporarilyDismissed(this.upsellId);
        } else {
          this.service.markUpsellAsTemporarilyDismissed(this.parentUpsell, this.industry);
        }
        this.service.trackEvent(this.upsellType, this.industry, null, cta);
        window.open(cta.action.route, '_blank');
      });
    }
    if (cta.action.type === CTA_ACTION_TYPES.redirect) {
      if (this.parentUpsell === EXPANSION_UPSELL_TYPES.SIDEBAR) {
        this.service.markSidebarUpsellAsTemporarilyDismissed(this.upsellId);
      } else {
        this.service.markUpsellAsTemporarilyDismissed(this.parentUpsell, this.industry);
      }
      this.onClose.emit();
      window.open(cta.action.route, '_blank');
    }
  }

  public getCTAText(cta: IUpsellCTA): string {
    if (typeof cta.text === 'string') {
      return cta.text;
    }
    return cta.text[this.service.getUserLanguage()];
  }
}